/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransferReport
 */
export interface TransferReport {
    /**
     * Timestamp of when the report was generated
     * @type {string}
     * @memberof TransferReport
     */
    date: string;
    /**
     * Number of digital objects, excluding metadata files
     * @type {number}
     * @memberof TransferReport
     */
    numberOfComputerFiles: number;
    /**
     * Number of critical and non-critical mandatory errors
     * @type {number}
     * @memberof TransferReport
     */
    numberOfErrors: number;
    /**
     * Number of SIPs created from the transfer
     * @type {number}
     * @memberof TransferReport
     */
    numberOfItems: number;
    /**
     * The report title
     * @type {string}
     * @memberof TransferReport
     */
    title: string;
    /**
     * Total size in bytes
     * @type {number}
     * @memberof TransferReport
     */
    totalSize: number;
    /**
     * Transfer batch number
     * @type {string}
     * @memberof TransferReport
     */
    transferBatchNumber: string;
    /**
     * Transfer date
     * @type {Date}
     * @memberof TransferReport
     */
    transferDate: Date;
    /**
     * Identifier of the transfer
     * @type {string}
     * @memberof TransferReport
     */
    transferId: string;
    /**
     * Transfer status at report generation
     * @type {string}
     * @memberof TransferReport
     */
    transferOutcome: string;
    /**
     * Transferring agency
     * @type {string}
     * @memberof TransferReport
     */
    transferringAgency: string;
}

/**
 * Check if a given object implements the TransferReport interface.
 */
export function instanceOfTransferReport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "numberOfComputerFiles" in value;
    isInstance = isInstance && "numberOfErrors" in value;
    isInstance = isInstance && "numberOfItems" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "totalSize" in value;
    isInstance = isInstance && "transferBatchNumber" in value;
    isInstance = isInstance && "transferDate" in value;
    isInstance = isInstance && "transferId" in value;
    isInstance = isInstance && "transferOutcome" in value;
    isInstance = isInstance && "transferringAgency" in value;

    return isInstance;
}

export function TransferReportFromJSON(json: any): TransferReport {
    return TransferReportFromJSONTyped(json, false);
}

export function TransferReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'numberOfComputerFiles': json['number_of_computer_files'],
        'numberOfErrors': json['number_of_errors'],
        'numberOfItems': json['number_of_items'],
        'title': json['title'],
        'totalSize': json['total_size'],
        'transferBatchNumber': json['transfer_batch_number'],
        'transferDate': (new Date(json['transfer_date'])),
        'transferId': json['transfer_id'],
        'transferOutcome': json['transfer_outcome'],
        'transferringAgency': json['transferring_agency'],
    };
}

export function TransferReportToJSON(value?: TransferReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'number_of_computer_files': value.numberOfComputerFiles,
        'number_of_errors': value.numberOfErrors,
        'number_of_items': value.numberOfItems,
        'title': value.title,
        'total_size': value.totalSize,
        'transfer_batch_number': value.transferBatchNumber,
        'transfer_date': (value.transferDate.toISOString().substr(0,10)),
        'transfer_id': value.transferId,
        'transfer_outcome': value.transferOutcome,
        'transferring_agency': value.transferringAgency,
    };
}

